import { Action } from '@ngrx/store'
import * as LayersTypes from './layer.types'
import { Layer } from './layer.interface'

// Fetch Layer Types
export class FetchLayersRequest implements Action {
  readonly type = LayersTypes.FETCH_LAYERS_REQUEST
  constructor(public payload: any = {}) {}
}

export class FetchLayersSuccess implements Action {
  readonly type = LayersTypes.FETCH_LAYERS_SUCCESS
  constructor(
    public payload: Layer[],
    public total: number,
    public results: number,
  ) {}
}

export class FetchLayersFailure implements Action {
  readonly type = LayersTypes.FETCH_LAYERS_FAILURE
  constructor(public payload: any) {}
}

// Fetch Layer Type
export class FetchLayerRequest implements Action {
  readonly type = LayersTypes.FETCH_LAYER_REQUEST
  constructor(public id: number) {}
}

export class FetchLayerSuccess implements Action {
  readonly type = LayersTypes.FETCH_LAYER_SUCCESS
  constructor(public payload: Layer) {}
}

export class FetchLayerFailure implements Action {
  readonly type = LayersTypes.FETCH_LAYER_FAILURE
  constructor(public payload: any) {}
}

// Delete Layer Type
export class DeleteLayerRequest implements Action {
  readonly type = LayersTypes.DELETE_LAYER_REQUEST
  constructor(public id: number) {}
}

export class DeleteLayerSuccess implements Action {
  readonly type = LayersTypes.DELETE_LAYER_SUCCESS
  constructor() {}
}

export class DeleteLayerFailure implements Action {
  readonly type = LayersTypes.DELETE_LAYER_FAILURE
  constructor(public payload: any) {}
}

// Create Layer Type
export class CreateLayerRequest implements Action {
  readonly type = LayersTypes.CREATE_LAYER_REQUEST
  constructor(public payload) {}
}

export class CreateLayerSuccess implements Action {
  readonly type = LayersTypes.CREATE_LAYER_SUCCESS
  constructor() {}
}

export class CreateLayerFailure implements Action {
  readonly type = LayersTypes.CREATE_LAYER_FAILURE
  constructor(public payload: any) {}
}

// Update Layer Type
export class UpdateLayerRequest implements Action {
  readonly type = LayersTypes.UPDATE_LAYER_REQUEST
  constructor(public id: number, public payload) {}
}

export class UpdateLayerSuccess implements Action {
  readonly type = LayersTypes.UPDATE_LAYER_SUCCESS
  constructor() {}
}

export class UpdateLayerFailure implements Action {
  readonly type = LayersTypes.UPDATE_LAYER_FAILURE
  constructor(public payload: any) {}
}

export class UploadLayerFileRequest implements Action {
  readonly type = LayersTypes.UPLOAD_LAYER_FILE_REQUEST
  constructor(public id: number, public payload) {}
}

export class UploadLayerFileSuccess implements Action {
  readonly type = LayersTypes.UPLOAD_LAYER_FILE_SUCCESS
  constructor(public payload: any) {}
}

export class UploadLayerFileFailure implements Action {
  readonly type = LayersTypes.UPLOAD_LAYER_FILE_FAILURE
  constructor(public payload: any) {}
}

// Common

export class UpdateField implements Action {
  readonly type = LayersTypes.UPDATE_FIELD
  public constructor(
    public field: string,
    public value: any,
    public path: string,
  ) {}
}

export class SetDefaultData implements Action {
  readonly type = LayersTypes.SET_DEFAULT_DATA
  public constructor(public path: string) {}
}

export type Actions =
  | UpdateLayerRequest
  | UpdateLayerSuccess
  | UpdateLayerFailure
  | FetchLayersSuccess
  | FetchLayersFailure
  | FetchLayersRequest
  | FetchLayerSuccess
  | FetchLayerFailure
  | FetchLayerRequest
  | CreateLayerRequest
  | CreateLayerSuccess
  | CreateLayerFailure
  | DeleteLayerRequest
  | DeleteLayerSuccess
  | DeleteLayerFailure
  | SetDefaultData
  | UpdateField
  | FetchLayersRequest
  | FetchLayersSuccess
  | FetchLayersFailure
  | UploadLayerFileRequest
  | UploadLayerFileSuccess
  | UploadLayerFileFailure
